import { render, staticRenderFns } from "./MintalMesPrdPelletizingIngredientPlanItemEdit.vue?vue&type=template&id=2970b55a&"
import script from "./MintalMesPrdPelletizingIngredientPlanItemEdit.vue?vue&type=script&lang=js&"
export * from "./MintalMesPrdPelletizingIngredientPlanItemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports